import React from 'react'
import plusButtonSvg from '@assets/ultra-play/ultra-play-plus-button.svg'
import minusButtonSvg from '@assets/ultra-play/ultra-play-minus-button.svg'

// The minus/plus button pair used in the portrait footer (BET and SPINS).
const UltraPlayStepper: React.FC<{
    onDecrement: () => void
    onIncrement: () => void
    canDecrement: boolean
    canIncrement: boolean
    disabled?: boolean
}> = ({ onDecrement, onIncrement, canDecrement, canIncrement, disabled }) => (
    <div className="flex w-[130px] h-[58px]">
        <button
            onClick={onDecrement}
            disabled={!canDecrement || disabled}
            className="flex-shrink-0 disabled:opacity-40"
        >
            <img src={minusButtonSvg} width={67} height={58} alt="-" />
        </button>
        <button
            onClick={onIncrement}
            disabled={!canIncrement || disabled}
            className="flex-shrink-0 disabled:opacity-40 -ml-1"
        >
            <img src={plusButtonSvg} width={67} height={58} alt="+" />
        </button>
    </div>
)

export default UltraPlayStepper
